import React, { useState } from "react";
import { CancelButton, SaveButton, DrawerComponent } from "@comps/components";
import { makeRequest, notify } from "@utils/helpers";
import { updateUserReq } from "../requests";

import UserForm from "./UserForm";

const formName = "users";
const UpdateUser = (props) => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  const onFinish = (data) => {
    let payload = {
      "object": {
        ...data,
        id: props.data.id
      }
    }
    makeRequest(setLoader, updateUserReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("User Updated", res.msg);
    props.onUpdated(data.object);
  }

  const onError = (err) => {
    let errorList = [];
    errorList['name'] = err.name;
  }

  return (
    <DrawerComponent mainTitle="Update" subTitle="User" open={ true } footer={ false } onClose={ () => props.onClosed(false) }>
      <UserForm setErrors={ setErrors } errors={ errors } preData={ {
        roles: props.roles
      } } initialData={ props.data } onFinish={ onFinish } formName={ formName } />
      <div className="form-actions">
        <CancelButton key="close_button" onClick={ () => props.onClosed(false) } />
        <SaveButton form={ formName } key="create_button" htmlType="submit" state={ loader } />
      </div>
    </DrawerComponent>
  );
}

export default UpdateUser
